namespace advisorop.components.advisor {
    

    class InvestorLookupController {
        public investorResult: domains.ISearchInvestorHouseholdResults;

        static $inject = ["advisorService", "servicerService", "$filter", "$rootRouter"];
        constructor(private advisorService: services.AdvisorService, private servicerService: services.ServicerService,
            public $filter,
            public $rootRouter) {        
        }
        
        searchItems(searchTerm: string): ng.IPromise<Array<{}>> {
            return this.servicerService.searchInvestorsAll(searchTerm).then((response) => {
                return response.data;
            });
        }

        onSelectItem(item, model, label, event): void {
            this.investorResult = item;
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {            
        }
    }

    //title 3 types indvidual , joint more than one, custodian 
    class InvestorLookup implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = InvestorLookupController;
            this.controllerAs = "vm";
            this.bindings = {
                investorResult: "=",
            };
            this.templateUrl = "spa/advisor-module/components/investor-lookup.html";
        }

    }
    angular.module(Constants.APP).component("investorLookup", new InvestorLookup());
}